import React from "react";
import PropTypes from "prop-types";
import SelectInput from "../../../common/forms/SelectInput";

const RateFilter = React.forwardRef((props, ref) => {
  return <SelectInput default="All" label="Rate" onChange={props.onChange} options={props.rates.sort()} ref={ref} />;
});

RateFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  rates: PropTypes.array.isRequired,
};

export default React.memo(RateFilter);
